// ABOUTME: Performs an authenticated fetch using the current Supabase session token.
// ABOUTME: Throws on missing session or non-OK response so callers get clean errors.

import { supabase } from "../contexts/AuthContext";

export async function authedFetch<T>(
  url: string,
  init?: RequestInit,
): Promise<T> {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session?.access_token) {
    throw new Error("Not authenticated");
  }

  const response = await fetch(url, {
    ...init,
    headers: {
      ...init?.headers,
      Authorization: `Bearer ${session.access_token}`,
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Request failed: ${response.status}${errorText ? ` - ${errorText}` : ""}`,
    );
  }

  return response.json() as Promise<T>;
}
